import axios from 'axios'
import Country from '@/dto/deliveries/Country'
import Place from '@/dto/deliveries/Place'
import Region from '@/dto/deliveries/Region'

class LocationService {
  countries: Country[] = []
  countriesPromise: Promise<Country[]> | null = null

  getRussia(): Country {
    return this.countries.find(c => c.code === 'RU') as Country
  }

  async getCountries(): Promise<Country[]> {
    if (this.countries.length) {
      return this.countries
    }

    if (this.countriesPromise !== null) {
      return this.countriesPromise
    }

    this.countriesPromise = axios.get('/v1/geo/countries').then(response => {
      this.countries = response.data

      return this.countries
    })

    return this.countriesPromise
  }

  async getRegions(countryId: number, term: string): Promise<Region[]> {
    return axios
      .get(`/v1/geo/state`, { params: { countryId, term } })
      .then(response => response.data)
  }

  async getPlacesForRegion(regionId: number, term: string): Promise<Place[]> {
    const query: { term: string; stateId?: number } = { term }

    if (regionId) {
      query.stateId = regionId
    }

    return axios
      .get(`/v1/geo/city`, { params: query })
      .then(response => response.data)
  }

  async searchPlaces(countryId: number, term: string): Promise<Place[]> {
    return axios
      .get(`/v1/geo/search`, { params: { countryId, term } })
      .then(response => response.data)
  }

  getRegionsAndPlacesByPlaceNames(
    placeNames: string[]
  ): Promise<{ [key: string]: { states: Region[]; cities: Place[] } }> {
    return axios
      .get(`/v1/geo/city`, { params: { cityNames: placeNames } })
      .then(response => response.data)
  }
}

export default new LocationService()
